export default "__VITE_ASSET__oSyY2dPs__"